/*
----- Service Worker ----- 

- Checks whether browser supports service workers.
- Actually registers / registers the service worker.

*/

// Added url parameter to eventually get rid of disable-service-worker parameter, so we can completely disable in production for debugging and only enable for specific cases 846212.
// Client override.
const urlParameters = new URLSearchParams(document.location.search);
// Service Worker Location.
const serviceWorkerLocation = '/service-worker.js';


var clientDisableStatus = urlParameters.get("service-worker-enabled");
if (clientDisableStatus != undefined) {
    // Convert to bool.
    clientDisableStatus = (clientDisableStatus == "true");
    // Set local storage.
    localStorage.setItem('service-worker-enabled', clientDisableStatus);
} else {
    // Check local storage.
    clientDisableStatus = localStorage.getItem('service-worker-enabled');
    // If returns "true" or is not set ( i.e. null ) default to always on.
    if (clientDisableStatus == "true" || clientDisableStatus == null) {
        clientDisableStatus = true;
    } else {
        clientDisableStatus = false;
    }
}
// Used to completely disable and un-register a service worker if previousily applied.
const serviceWorkerEnabled = (clientDisableStatus != undefined ? clientDisableStatus : true);

var instances = {};
var instanceId = "serviceWorkerInstance";

function getContext(id) {
    return instances[id]['context'];
}

function setContext(id, value) {
    return instances[id]['context'] = value;
}

function getState(id) {
    return (instances.hasOwnProperty(id) ? instances[id]['state'] : false);
}

function setState(id, value) {
    if (AXISDebug.getDebugDrawerState()) {
        // Update status in drawer.
        AXISDebug.updateDrawerStatus("service-worker-status", value);
    }
    return (instances.hasOwnProperty(id) ? instances[id]['state'] = value : false);
}

function initialise() {
    // Check if service worker is supported.
    if (browserServiceWorkerSupported()) {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1, "Service Worker: Browser supports service workers.");
        }
        // Old disable mechanism, you should use service-worker-enabled instead, this will eventually get worked out the system.
        // Check if is we should be disabling the service worker? 
        let disableServiceWorker = getUrlParameter('disable-service-worker');
        if (disableServiceWorker != undefined) {
            // Convert to bool.
            disableServiceWorker = (disableServiceWorker == "true");
            // Set local storage.
            localStorage.setItem('disable-service-worker', disableServiceWorker);
        } else {
            // Check local storage.
            disableServiceWorker = (localStorage.getItem('disable-service-worker') == "true");
        }
        if (!disableServiceWorker && serviceWorkerEnabled) {
            // Create instance
            // TODO: as we only currently have one.
            let id = instanceId;
            instances[id] = {};

            $(window).on('load', () => {
                // Install service worker.
                navigator.serviceWorker.register(serviceWorkerLocation).then((worker) => {

                    setContext(id, worker);
                    if (AXISDebug.level() >= 3) {
                        AXISDebug.output(1, "Service worker registration successful the scope is: ", worker.scope)
                    }

                    if (worker.installing) {
                        let state = "";
                        if (worker.installing) {
                            state = worker.installing;
                        } else if (worker.waiting){
                            state = worker.waiting;
                        } else if (worker.active) {
                            state = worker.active;
                        }
                        setState(id, state);
                        // When the state changes then set state in instance obj.
                        state.addEventListener('statechange', (cb) => {
                            // Set state.
                            setState(id, cb.target.state)
                        });
                    } else {
                        setState(id, worker['active']['state']);
                    }
                }, (error) => {
                    console.log(error)
                    AXISDebug.output(3,"Service Worker: registration failed error: ", error);
                });
            });
        } else {
            if(AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Service Worker: Service worker disable override", disableServiceWorker);
            }
            // Are there any regisered service workers? 
            remove();
            setState(id, "disabled");
        }
    } else {
        if (AXISDebug.level() >= 2) {
            AXISDebug.output(1, "Service Worker: Browser doesn't support service workers");
        }
    }
}

function remove() {
    console.log("Service Worker: Attempting to remove service worker");
    // Forcing unintall.
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
        if (registrations.length) {
            console.log("Service Worker: Active service workers for this site: ", registrations);
            for(let registration of registrations) {
                registration.unregister().then((status) => {
                    console.log("Service Worker: Service worker unregistered", status);
                    
                }).catch((error) => {
                    console.log("Service Worker: Service worker unregistration failed", error);
                });
            } 

            setState(instanceId, "Unregistered"); 
        } else {
            console.log("Service Worker: No Active Service Workers found for this site.");
        }
    });
    // Clear caches 
    caches.keys().then(function(keys) {
        if (keys.length) {
            console.log("Service Worker: Attempting to clear cache storage here are the caches found: ", keys);
            // Clear all cache keys.
            keys.forEach(function(request, index, array) {
                caches.delete(request);
            });
        }
    });
}

// Check the server for an updated service worker.
async function updateServiceWorker() {
    if (browserServiceWorkerSupported()) {
        return new Promise((resolve, reject) => {
             // Current there is only one.
            let instance = instances[instanceId];
            // Get worker.
            let worker = instance['context'];
            // Update.
            worker.update().then((worker) => {
                setContext(instanceId, worker);
                resolve(worker);
            }).catch((error) => {
                reject(error);
            })
        });
    } else { 
        return Promise.reject("This browser doesn't support service workers");
    }
}

function browserServiceWorkerSupported() {
    let supported = ("serviceWorker" in navigator);
    return supported;
}

var AXISServiceWorker = $.AXISServiceWorker = {
    initialise: () => {
        return initialise();
    },
    remove: () => {
        return remove();
    },
    getState: () => {
        return getState(instanceId);
    },
    update: () => {
        return updateServiceWorker();
    },
    supported: () => {
        return browserServiceWorkerSupported();
    }
}
 
export { AXISServiceWorker };